"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteScheduler = deleteScheduler;
exports.fetchScheduler = fetchScheduler;
exports.delaySend = delaySend;
exports.delaySendCompose = delaySendCompose;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _set = _interopRequireDefault(require("lodash/set"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _utils2 = require("../utils");

var endpoints = {
  "delete": {
    method: 'DELETE',
    url: function url(schedulerId) {
      return "/".concat(_utils2.API_V1, "/scheduler/").concat(schedulerId);
    }
  },
  fetch: {
    method: 'GET',
    url: function url(schedulerId) {
      return "/".concat(_utils2.API_V1, "/scheduler/exec_info/").concat(schedulerId);
    }
  },
  delaySend: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/scheduler/compose_send");
    }
  },
  delaySendCompose: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/scheduler/compose/send");
    }
  }
};
/**
 * Undo send draft
 * @param { string } schedulerId
 * @param { Auth } auth auth token
 */

exports.endpoints = endpoints;

function deleteScheduler(_x, _x2) {
  return _deleteScheduler.apply(this, arguments);
}
/**
 * Fetch scheduler execute result
 * @param {string} schedulerId
 * @param { Auth } auth auth token
 */


function _deleteScheduler() {
  _deleteScheduler = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(schedulerId, _ref) {
    var auth, optionals, _endpoints$delete, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
            _context.next = 5;
            return (0, _requests.request)(url(schedulerId), method, optionals);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _deleteScheduler.apply(this, arguments);
}

function fetchScheduler(_x3, _x4) {
  return _fetchScheduler.apply(this, arguments);
}
/**
 * Delay send draft
 * @param { body, delay } draft compose body, delay time(s)
 * @param { Auth } auth auth token
 */


function _fetchScheduler() {
  _fetchScheduler = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(schedulerId, _ref2) {
    var auth, optionals, _endpoints$fetch, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            auth = _ref2.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$fetch = endpoints.fetch, method = _endpoints$fetch.method, url = _endpoints$fetch.url;
            _context2.next = 5;
            return (0, _requests.request)(url(schedulerId), method, optionals);

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchScheduler.apply(this, arguments);
}

function delaySend(_x5, _x6) {
  return _delaySend.apply(this, arguments);
}
/**
 * Delay send compose
 * @param { composeId, delay } draft compose body, delay time(s)
 * @param { Auth } auth auth token
 */


function _delaySend() {
  _delaySend = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3, _ref4) {
    var body, delay, auth, optionals, _endpoints$delaySend, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            body = _ref3.body, delay = _ref3.delay;
            auth = _ref4.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              body: body,
              delay: delay
            }))(_utils.defaultOptionals);
            _endpoints$delaySend = endpoints.delaySend, method = _endpoints$delaySend.method, url = _endpoints$delaySend.url;
            _context3.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _delaySend.apply(this, arguments);
}

function delaySendCompose(_x7, _x8) {
  return _delaySendCompose.apply(this, arguments);
}

function _delaySendCompose() {
  _delaySendCompose = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref5, _ref6) {
    var composeId, delay, auth, optionals, _endpoints$delaySendC, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            composeId = _ref5.composeId, delay = _ref5.delay;
            auth = _ref6.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              composeId: composeId,
              delay: delay
            }))(_utils.defaultOptionals);
            _endpoints$delaySendC = endpoints.delaySendCompose, method = _endpoints$delaySendC.method, url = _endpoints$delaySendC.url;
            _context4.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _delaySendCompose.apply(this, arguments);
}
//# sourceMappingURL=schedulers.js.map